export default __webpack_public_path__ + "static/media/businessApparel.4fa372a4.JPG";